<template>
	<my-dialog  class="passwordDialog" dialogTitle="New Fleet" v-model:dialogVisible="dialogVisible" :config="{ width: '500px' }">
		<template #content>
      <el-row>
				<el-col :span="10" class="label">Current login password</el-col>
				<el-col :span="14">
          <el-input class="w320" placeholder="Current account login password" v-model="data.password"/>
				</el-col>
			</el-row>
      <el-row>
				<el-col :span="10" class="label">New login password</el-col>
				<el-col :span="14">
          <el-input class="w320" type="password" placeholder="Please use letters and mubbers" v-model="data.newPassword"/>
				</el-col>
			</el-row>
      <el-row>
				<el-col :span="10" class="label">Enter again</el-col>
				<el-col :span="14">
          <el-input class="w320" type="password" placeholder="Please use letters and mubbers" v-model="data.newPasswordConfirm"/>
				</el-col>
			</el-row>

		</template>
		<template #footer>
			<div class="footer_wrap">
				<el-button round @click="handleClose">Cancel</el-button>
				<el-button round type="primary" @click="addGroup">Confirm</el-button>
			</div>
		</template>
	</my-dialog>
</template>

<script setup>
	import MyDialog from "@/components/dialog.vue";
	import { defineModel, reactive } from "vue";
	import $http from "@/api";
	import { useUserInfoStore } from "../stores/userInfoStore";
	const { userInfo } = useUserInfoStore();

	const dialogVisible = defineModel("dialogVisible");
	const data = reactive({
		passwrod: "",
		newPassword: "",
    newPasswordConfirm:"",
	});
  // const {password, newPassword, newPasswordConfirm} = toRefs(data)
  // const emit = defineEmits(['changeStatus',])
	const handleClose = () => {
		dialogVisible.value = false;
	};
  //添加团体
  const addGroup = () => {
    const groupInfo = {
      loginId: userInfo.loginId, // 登录用户ID。REQUIRED
      password: data.password, // 当前使用的密码。REQUIRED
      newPassword: data.newPassword // 新的密码。REQUIRED
    }

    if(data.password == ''){
      ElMessage.error('Please enter the password')
      return
    }
    if(data.newPassword == ''){
      ElMessage.error('Please enter the new password')
      return
    }
    if(data.newPasswordConfirm == ''){
      ElMessage.error('Please enter the new password again')
      return
    }
    if(data.newPassword != data.newPasswordConfirm){
      ElMessage.error('The two passwords are different')
      return
    }
		$http.login.resetPassword(groupInfo).then(res => {
      if(res.result) {
        dialogVisible.value = false;
        ElMessage.success('Reset password successfully!')
      } 
      else  ElMessage.error(res.error.msg ? res.error.msg : res.error.code)
      // emit('changeStatus')
		});
  }
  const numberCheck = (value,type) => {
      console.log(value,type)
      // if(value == '' || value == ' ' || isNaN(value)){
      //   return type == 1 ? data.password = '':type == 2 ? data.newPassword = '' : data.newPasswordConfirm = ''
      // }
      // if(type ==2 && !(value % 1 === 0)){
      //   return  data.maxUnpaidChargeBills = ''
      // }
      // if(value <= 0){
      //   return type == 1 ?  data.maxUnpaidChargeBillAmount = '': data.maxUnpaidChargeBills = ''
      // }
    }
</script>

<style lang="scss" scoped>
.w320 {
			width: 180px;
		}
	.el-row {
		padding: 34px 0;
		border-bottom: 1px dashed;
    @include border_color("border_line_color");
		&:first-child {
			padding-top: 0px;
		}
		.label {
			color: #404040;
		}
	}
</style>
<style lang="scss">
.passwordDialog{
  height: 500px;
}
</style>
